// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LeftMenu":"ir_a bhy_tr","LeftMenu__link":"ir_b bhy_vt bhy_a bhy_rc","LeftMenu__link__icon":"ir_c"};